import * as React from 'react'
import ContentLoader from 'react-content-loader'
import { Col, Row } from 'react-styled-flexboxgrid'
import { ListCardLoader } from '../../../components/ListCard'
import Resizable from '../../../interfaces/Resizable'
import { Container, StyledCol, StyledRow } from './style'

export const MDDimensionLoader: React.FC<Resizable> = ({ height, width = '100%' }) => (
  <ContentLoader
    height={42}
    width={500}
    speed={2}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
    style={{ height, width }}
  />
)

const Loader: React.FC = () => {
  return (
    <>
      <Col xs={12} md={12}>
        <Container>
          {[0, 1, 2].map((_, index) => (
            <ListCardLoader key={index}>
              <div>
                <Row>
                  <Col xs={12} md={6}>
                    <StyledRow>
                      <StyledCol xs={12} md={3} className="no-padding-bottom">
                        <MDDimensionLoader height="23px" />
                      </StyledCol>
                    </StyledRow>
                    <StyledRow>
                      <StyledCol xs={12} md={4} className="margin-bottom-xxs no-padding-bottom">
                        <MDDimensionLoader height="23px" />
                      </StyledCol>
                    </StyledRow>
                    <StyledRow>
                      <StyledCol xs={12} md={3} className="margin-bottom-xxs no-padding-bottom">
                        <MDDimensionLoader height="23px" />
                      </StyledCol>
                    </StyledRow>
                  </Col>
                </Row>
              </div>
            </ListCardLoader>
          ))}
        </Container>
      </Col>
    </>
  )
}

export default Loader
